module.exports = __webpack_public_path__ + "static/media/canal-02.272a3c2f.png";